import images from "./images";

const portfolio = [
    {
        id: 1,
        image: images.portfolio1,
        title: "Elegant Wedding Cakes",
        details: {
            date: "April 22, 2024",
            client: "Sweet Delight Bakery",
            category: "Custom Cake",
            duration: "2 Weeks",
            location: "Downtown Bakery Studio",
            value: "$850",
            headBaker: "Lisa Doe",
        },
        paragraphs: [
            "The Elegant Wedding Cakes project was created to design and craft bespoke wedding cakes that reflected each couple’s unique style and celebration theme. Our goal was to merge creativity with craftsmanship to deliver memorable centerpiece desserts for their special day.",
            "By using premium ingredients, intricate design techniques, and close client collaboration, the project successfully produced wedding cakes that delighted both the eye and the palate. Each cake was meticulously handcrafted to match the event's color scheme and ambiance."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6,
        ],
        services: [
            "Custom cake flavor and filling options",
            "Personalized design consultations",
            "Edible floral and fondant artistry",
            "Tiered structure assembly and transport",
            "On-site cake setup and styling",
        ],
        customization: [
            "Worked closely with couples to finalize themes",
            "Used hand-painted fondant details",
            "Incorporated seasonal flowers for decor",
            "Adapted recipes for dietary preferences",
            "Ensured safe transport with secure packaging",
        ],
        results: [
            "Delivered 100% client satisfaction ratings",
            "Achieved flawless cake setup at venues",
            "Enhanced brand recognition in wedding markets",
            "Received multiple referrals for future weddings",
            "Built a portfolio of diverse and elegant wedding cakes",
        ]
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Culinary Classes",
        details: {
            date: "May 15, 2024",
            client: "Sweet Delight Bakery",
            category: "Workshops",
            duration: "1 Month",
            location: "Sweet Delight Baking Studio",
            value: "$500",
            headBaker: "Michael Brown",
        },
        paragraphs: [
            "The Culinary Classes project was launched to empower baking enthusiasts and aspiring chefs with hands-on experience and expert guidance. Our mission was to cultivate a community of passionate bakers by sharing professional techniques in a friendly, interactive environment.",
            "The classes covered a variety of topics including cake decorating, bread making, and pastry creation. Participants enjoyed a collaborative learning experience, gaining skills they could take home and use in their personal or professional baking journeys."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6,
        ],
        services: [
            "Hands-on baking sessions",
            "Cake and pastry decorating techniques",
            "Recipe customization guidance",
            "Ingredient selection and preparation",
            "Small group learning for personalized attention",
        ],
        customization: [
            "Tailored class topics to participant interests",
            "Created beginner to advanced lesson plans",
            "Offered seasonal and holiday-themed workshops",
            "Provided take-home recipes and toolkits",
            "Hosted guest bakers for specialty sessions",
        ],
        results: [
            "Improved community engagement through learning",
            "Built a loyal following of workshop attendees",
            "Expanded Sweet Delight’s educational services",
            "Fostered creativity and baking confidence",
            "Generated positive word-of-mouth referrals",
        ]
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Holiday Gift Collections",
        details: {
            date: "December 05, 2024",
            client: "Corporate & Individual Clients",
            category: "Gift Hampers",
            duration: "2 Weeks",
            location: "Sweet Delight Bakery",
            value: "$2000",
            headBaker: "Emily White",
        },
        paragraphs: [
            "The Holiday Gift Collections project brought festive cheer to life with curated gift hampers filled with our finest bakery delights. Designed for both corporate gifting and personal celebrations, these collections blended creativity, quality, and customization.",
            "We offered a variety of hamper sizes, themes, and product assortments including cookies, mini cakes, artisanal breads, and seasonal treats. Custom packaging and personal notes were included for a thoughtful touch, making each gift truly memorable."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6,
        ],
        services: [
            "Curated festive hampers",
            "Personalized packaging options",
            "Corporate bulk orders",
            "Assorted seasonal baked goods",
            "Nationwide delivery options",
        ],
        customization: [
            "Created themed hampers for Christmas, New Year, and Thanksgiving",
            "Added personalized messages and gift tags",
            "Offered eco-friendly packaging options",
            "Worked with corporate clients for branded gifts",
            "Adjusted contents based on dietary preferences",
        ],
        results: [
            "Increased holiday season sales",
            "Strengthened corporate client relationships",
            "Enhanced Sweet Delight’s gifting reputation",
            "Received glowing customer feedback",
            "Established annual holiday hamper tradition",
        ]
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "Event Catering",
        details: {
            date: "April 15, 2025",
            client: "Various Corporate & Private Events",
            category: "Catering",
            duration: "1 Month",
            location: "Multiple Venues",
            value: "$5000",
            headBaker: "Michael Brown",
        },
        paragraphs: [
            "The Event Catering project focused on delivering exquisite bakery experiences for a range of events including weddings, corporate functions, and private parties. Our catering service featured customized dessert tables, signature pastries, and freshly baked breads designed to complement each event's theme.",
            "Our team managed on-site setup, ensured fresh preparation, and provided attentive service throughout the event. With a focus on presentation and flavor, we created unforgettable culinary moments for all guests."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6,
        ],
        services: [
            "Custom dessert tables",
            "On-site baking and setup",
            "Themed pastry arrangements",
            "Corporate and private event packages",
            "Professional serving staff",
        ],
        customization: [
            "Designed event-specific dessert menus",
            "Incorporated seasonal and themed treats",
            "Provided vegan and gluten-free options",
            "Styled setups to match event decor",
            "Offered interactive live baking stations",
        ],
        results: [
            "Successfully catered over 25 events",
            "Achieved high client satisfaction ratings",
            "Increased brand visibility in the event space",
            "Secured repeat event bookings",
            "Strengthened partnerships with event planners",
        ]
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Birthday Cake Creations",
        details: {
            date: "May 22, 2025",
            client: "Multiple Private Clients",
            category: "Custom Cake",
            duration: "2 Weeks",
            location: "Sweet Delight Bakery, Main Branch",
            value: "$2000",
            headBaker: "Emily White",
        },
        paragraphs: [
            "The Birthday Cake Creations project celebrated the art of personalized baking, crafting unique cakes tailored to each client’s vision. From whimsical children's cakes to elegant adult birthday designs, we delivered memorable centerpiece desserts for every occasion.",
            "Our team worked closely with clients on themes, flavors, and decorations, ensuring that each cake reflected personal style and celebration spirit. Every creation combined visual artistry with irresistible flavors."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6,
        ],
        services: [
            "Theme-based cake design",
            "Custom fondant and buttercream decorations",
            "Flavor customization",
            "Personalized cake toppers",
            "On-time delivery & setup",
        ],
        customization: [
            "Collaborated with clients on color schemes and themes",
            "Created edible figurines and characters",
            "Incorporated surprise elements like candy fillings",
            "Adapted cakes for dietary restrictions",
            "Provided packaging for safe transport",
        ],
        results: [
            "Crafted over 50 unique birthday cakes",
            "Received glowing reviews from clients",
            "Expanded our custom cake clientele",
            "Showcased cakes in social media campaigns",
            "Enhanced reputation as a go-to bakery for special occasions",
        ]
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Baking Masterclasses",
        details: {
            date: "June 15, 2025",
            client: "Open to Public",
            category: "Workshops",
            duration: "1 Week",
            location: "Sweet Delight Bakery Studio",
            value: "$800",
            headBaker: "Michael Brown",
        },
        paragraphs: [
            "The Baking Masterclasses were designed to inspire and educate baking enthusiasts of all skill levels. Participants learned essential baking techniques, from the basics of bread making to the artistry of cake decoration.",
            "Each class combined hands-on experience with expert instruction, fostering creativity and confidence in the kitchen. Students left with not only new skills but also their own freshly baked creations."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6,
        ],
        services: [
            "Hands-on baking sessions",
            "Professional baking demonstrations",
            "Recipe handouts and guidance",
            "Ingredient preparation and sourcing",
            "Small group instruction for personal attention",
        ],
        customization: [
            "Tailored sessions for beginners and advanced bakers",
            "Covered pastries, bread, cakes, and cookies",
            "Provided take-home kits and supplies",
            "Interactive Q&A with the head baker",
            "Adapted classes for seasonal themes and holidays",
        ],
        results: [
            "Taught over 100 students during the week",
            "Enhanced community engagement",
            "Expanded the bakery’s reach as an educational hub",
            "Inspired participants to start their own baking journeys",
            "Received positive feedback and repeat class signups",
        ]
    }

];

export default portfolio;